import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  BasicAccordion,
  BasicTable,
  CardComponent,
  cellStyles4,
  Columns,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import CasesTabMessages from '../../../core-utils/messages/CareNavigatorConstants';
import Loader from '../../molecules/Loader';
import { dropDownMenuItemsAlphabets } from '../../../core-utils/helper-utils/tableSortHelper';
import { getInfoIcon } from '../../../core-utils/helper-utils/infoIconHelper';
import {
  formatActivePatients,
  formatClosedPatients,
  formatUnassignedPatients,
} from '../../../core-utils/helper-utils/careNavigatorHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../atoms/Snackbar';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import { useStores } from '../../../stores';
import AssignCareNavModal from '../AssignCareNavModal';
import {
  decryptData,
  getPriorityButton,
} from '../../../core-utils/helper-utils/helper';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import {
  CARE_NAVIGATOR,
  CARE_NAVIGATOR_PROFILE,
  PATIENT_CASES,
} from '../../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import AcceptCaseModal from '../AcceptCaseModal';
import DeleteGroupConfirmModal from '../DeleteGroupConfirmModal';

export interface CasesTabProps {}

const careNavColumns: Columns[] = [
  {
    name: 'Member Name',
    align: 'left',
    cellStyles: cellStyles4,
    width: '150px',
  },
  {
    name: 'Condition',
    align: 'left',
    cellStyles: cellStyles4,
    width: '220px',
  },
  {
    name: 'Priority',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
  },
];

const CasesTab: React.FC<CasesTabProps> = ({}) => {
  const useStyles = makeStyles()({
    accordion: {
      margin: '10px 0px',
    },
    rightItem: {
      display: 'flex',
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
    },
    rightItemTitle: {
      borderRadius: '4px 0px 0px 4px',
      padding: '3px 8px',
    },
    rightItemValue: {
      background: patientAccessTheme.palette.grey[100],
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderRadius: '0px 4px 4px 0px',
      padding: '3px 8px',
    },
    emptyData: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: '20px',
    },
  });

  const messages = CasesTabMessages.CARE_NAVIGATOR_PAGE.MEMBERS_DATA;

  const cellStyles = {
    color: patientAccessTheme.palette.text.highemphasis,
    fontSize: '12px',
    fontWeight: 500,
  };

  const unassignedTableColumns: any[] = [
    {
      name: 'Patient Name',
      sortColumnName: 'name',
      align: 'left',
      cellStyles: cellStyles4,
      width: '180px',
      showEllipsis: true,
      ellipsisWidth: '170px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Priority',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
    },
    // {
    //   name: 'Conditions',
    //   align: 'left',
    //   cellStyles: cellStyles4,
    //   width: '150px',
    // },
    {
      name: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            ...cellStyles,
          }}
        >
          <div>Type Of Trigger</div>
          <div>
            {getInfoIcon('Type of trigger of patient', () => {}, {
              display: 'flex',
              alignItems: 'center',
            })}
          </div>
        </div>
      ),
      align: 'left',
      cellStyles: cellStyles4,
      width: '200px',
    },
    {
      name: 'Care Navigator',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
    },
    {
      name: 'Action',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
    },
    {
      name: '',
      align: 'left',
      cellStyles: cellStyles4,
      width: '50px',
    },
  ];

  const activeTableColumns: any[] = [
    {
      name: 'Case ID',
      sortColumnName: 'caseId',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
      showEllipsis: true,
      ellipsisWidth: '80px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Created',
      sortColumnName: 'createdDate',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Patient',
      sortColumnName: 'patientName',
      align: 'left',
      cellStyles: cellStyles4,
      width: '200px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    // {
    //   name: 'Condition',
    //   align: 'left',
    //   cellStyles: cellStyles4,
    //   width: '130px',
    // },
    {
      name: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            ...cellStyles,
          }}
        >
          <div>Type Of Trigger</div>
          <div>
            {getInfoIcon('Type of trigger of patient', () => {}, {
              display: 'flex',
              alignItems: 'center',
            })}
          </div>
        </div>
      ),
      align: 'left',
      cellStyles: cellStyles4,
      width: '190px',
    },
    {
      name: 'Last Engagement',
      align: 'left',
      cellStyles: cellStyles4,
      width: '170px',
    },
    {
      name: 'Last Outreach',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
    },
    {
      name: 'Care Navigator',
      align: 'left',
      cellStyles: cellStyles4,
      width: '120px',
      showEllipsis: true,
      ellipsisWidth: '100px',
      showThisColumn: true,
    },
    {
      name: '',
      align: 'left',
      cellStyles: cellStyles4,
      width: '50px',
    },
  ];

  const closedTableColumns: any[] = [
    {
      name: 'Case ID',
      sortColumnName: 'caseId',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
      showEllipsis: true,
      ellipsisWidth: '80px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Created',
      sortColumnName: 'createdDate',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Closed',
      sortColumnName: 'closedDate',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Patient',
      sortColumnName: 'patientName',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsAlphabets,
    },
    {
      name: 'Case Type',
      align: 'left',
      cellStyles: cellStyles4,
      width: '100px',
    },
    {
      name: 'Engagements',
      align: 'left',
      cellStyles: cellStyles4,
      width: '60px',
    },
    {
      name: 'Savings',
      align: 'left',
      cellStyles: cellStyles4,
      width: '80px',
    },
    {
      name: 'Rating',
      align: 'left',
      cellStyles: cellStyles4,
      width: '140px',
    },
    {
      name: '',
      align: 'left',
      cellStyles: cellStyles4,
      width: '50px',
    },
  ];

  const careNavigatorStore = useStores().careNavigatorStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const loginPageStore = useStores().loginPageStore;
  const navigate = useNavigate();

  const [loader] = useState<any>(<Loader />);
  const [loading, setLoading] = useState<boolean>(true);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [unassignedData, setUnassignedData] = useState<any[]>([]);
  const [activeData, setActiveData] = useState<any[]>([]);
  const [closeData, setCloseData] = useState<any[]>([]);
  const [isAssignModal, setIsAssignModal] = useState<boolean>(false);
  const [isAcceptModal, setIsAcceptModal] = useState<boolean>(false);
  const [isReplaceModal, setIsReplaceModal] = useState<boolean>(false);
  const [careNavFieldsData, setCareNavFieldsData] = useState<any>({
    care_navigator_pharmacist: [],
    care_navigator_nurse: [],
    care_navigator_customer_service: [],
  });
  const [assignData, setAssignData] = useState<any>({
    name: '',
    case_id: '',
    priority: '',
    condition: '',
    cn_id: '',
    cn_name: '',
    cn_role: '',
    cn_assign_note: '',
    patient_created_by: '',
  });
  const [isDeleteGroupPopup, setIsDeleteGroupPopup] = useState<boolean>(false);
  const [deleteGroupData, setDeleteGroupData] = useState<any>({
    case_id: '',
    case_status: '',
  });

  const { classes } = useStyles();

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const getModalData = () => {
    const name = assignData.name
      ? assignData.patient_created_by === 'system'
        ? decryptData(assignData.name)
        : assignData.name
      : '-';

    return [
      [
        name.length > 16 ? getTextWithToolTip(name, 16) : name,
        assignData.condition
          ? assignData.condition.length > 20
            ? getTextWithToolTip(assignData.condition, 20)
            : assignData.condition
          : '-',
        <Grid
          style={{ color: getPriorityButton(assignData.priority).labelColor }}
        >
          {assignData.priority}
        </Grid>,
      ],
    ];
  };

  const handleCaseClick = (data: any) => {
    memberSummaryStore.removePathDetails();
    const pathDetails: any[] = [];
    pathDetails.push([
      'text',
      'Care Navigator',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => navigate(CARE_NAVIGATOR),
    ]);

    memberSummaryStore.setPathDetails(pathDetails);

    navigate(PATIENT_CASES, {
      state: {
        memberId: data.member_id,
        patientId: data.patient_id,
        caseId: data.case_id,
        isCaseClosed: data?.isCaseClosed || false,
      },
    });
    return;
  };

  const handleCareNavigatorCardClick = (_id: string) => {
    memberSummaryStore.removePathDetails();
    const pathDetails: any[] = [];
    pathDetails.push([
      'text',
      'Care Navigator',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => navigate(CARE_NAVIGATOR),
    ]);

    memberSummaryStore.setPathDetails(pathDetails);

    navigate(CARE_NAVIGATOR_PROFILE, {
      state: {
        care_navigator_id: _id,
      },
    });
  };

  const getCareNavData = async () => {
    return await axios.get(
      properties.userManagementBaseUrl +
        properties.careNavigator +
        properties.getByRole +
        '?groupId=' +
        careNavigatorStore.group_id,
    );
  };

  const handleAssignModal = (action: string, item: any) => {
    setAssignData({
      ...item,
      name: item.name || '-',
      patient_created_by: item.patient_created_by || '',
      case_id: item.case_id,
      cn_id: '',
      cn_name: '',
      cn_role: '',
      cn_assign_note: '',
    });
    if (action === 'Replace') {
      setIsReplaceModal(true);
    }
    if (action === 'Assign') {
      setIsAssignModal(true);
    }
    if (action === 'Accept') {
      setIsAcceptModal(true);
    }
    return;
  };

  const handleChangePriority = async (
    case_id: string,
    priority: string,
    group_id: string,
  ) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.casesBaseUrl +
          properties.updatePriority,
        {
          case_id: case_id,
          priority: priority,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const updatedData = unassignedData.map((group) => {
            if (group.group_id === group_id) {
              const updatedCases = group.cases.map((caseObj: any) => {
                if (caseObj.case_id && caseObj.case_id === case_id) {
                  return { ...caseObj, priority: priority };
                }
                return caseObj;
              });

              return { ...group, cases: updatedCases };
            }
            return group;
          });

          setUnassignedData(updatedData);
          handleOpenSnackBar('Priority changed succesfully', 'success', 6000);
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleSave = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.casesBaseUrl + properties.assignCase,
        {
          case_id: assignData.case_id,
          cn_id: assignData.cn_id,
          cn_name: assignData.cn_name,
          cn_role: assignData.cn_role,
          cn_assign_note: assignData.cn_assign_note,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleOpenSnackBar(
            'Care navigator added succesfully',
            'success',
            6000,
          );
        }
        setIsAssignModal(false);
        setIsReplaceModal(false);
        apiCalls();
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleAccept = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.casesBaseUrl + properties.acceptCase,
        {
          case_id: assignData.case_id,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          setIsAcceptModal(false);
          apiCalls();
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleSelfAssignAndAccept = async () => {
    const careNavData = loginPageStore.userResponse;
    if (!careNavData) {
      handleOpenSnackBar('Care navigator details not found', 'error', 6000);
      return;
    }

    await axios
      .post(
        properties.aiqBaseUrl + properties.casesBaseUrl + properties.assignCase,
        {
          case_id: assignData.case_id,
          cn_id: careNavData.cnId,
          cn_name: careNavData.firstName + ' ' + careNavData.lastName,
          cn_role: careNavData.role,
          cn_assign_note: assignData.cn_assign_note,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleAccept();
          handleOpenSnackBar(
            'Care navigator assigned & accepted succesfully',
            'success',
            6000,
          );
        }
        setIsAssignModal(false);
        setIsReplaceModal(false);
        apiCalls();
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const getUnassigned = async () => {
    return await axios.post(
      properties.aiqBaseUrl + properties.casesBaseUrl + properties.getCases,
      {
        group_ids: [careNavigatorStore.group_id],
        case_status: 'unassigned',
      },
    );
  };

  const getActive = async () => {
    return await axios.post(
      properties.aiqBaseUrl + properties.casesBaseUrl + properties.getCases,
      {
        group_ids: [careNavigatorStore.group_id],
        case_status: 'active',
      },
    );
  };

  const getClosed = async () => {
    return await axios.post(
      properties.aiqBaseUrl + properties.casesBaseUrl + properties.getCases,
      {
        group_ids: [careNavigatorStore.group_id],
        case_status: 'close',
      },
    );
  };

  const apiCalls = async () => {
    setLoading(true);
    await Promise.all([
      getUnassigned(),
      getActive(),
      getClosed(),
      getCareNavData(),
    ])
      .then((responses: any) => {
        responses.map((res: any) => {
          if (res?.status !== 200) {
            handleOpenSnackBar(res?.reason?.message, 'error', 6000);
          }
        });

        if (responses[0]?.status === 200) {
          setUnassignedData(responses[0]?.data?.data);
        }

        if (responses[1]?.status === 200) {
          setActiveData(responses[1]?.data?.data);
        }

        if (responses[2]?.status === 200) {
          setCloseData(responses[2]?.data?.data);
        }

        if (responses[3]?.status === 200) {
          setCareNavFieldsData(responses[3]?.data);
        }
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    apiCalls();
  }, []);

  const handleMenuOnClick = (menu: string, data: any) => {
    setDeleteGroupData(data);
    setIsDeleteGroupPopup(true);
  };

  const handleDeleteCase = async () => {
    if (!deleteGroupData.case_id) {
      return;
    }
    await axios
      .post(
        properties.aiqBaseUrl + properties.casesBaseUrl + properties.deleteCase,
        {
          case_id: deleteGroupData.case_id,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleOpenSnackBar('Case deleted succesfully', 'success', 6000);
        }
        setIsDeleteGroupPopup(false);
        apiCalls();
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const handleCloseDeleteGroup = () => {
    setIsDeleteGroupPopup(false);
  };

  return (
    <Grid>
      {loading ? (
        loader
      ) : (
        <Grid style={{ display: 'flex', flexDirection: 'column', gap: '26px' }}>
          <CardComponent
            title={messages.TITLE.unassigned}
            width="1176px"
            body={unassignedData?.map((item) => (
              <Grid className={classes.accordion}>
                <BasicAccordion
                  title={item.group_name}
                  width={'1141px'}
                  height={'70px'}
                  expandDefault={unassignedData.length === 1}
                  content={
                    item.cases?.length === 0 ? (
                      <Grid className={classes.emptyData}>
                        <NoDataVisual
                          content="No Data Available"
                          height="200px"
                        />
                      </Grid>
                    ) : (
                      <BasicTable
                        width="1105px"
                        columns={unassignedTableColumns}
                        rowsData={formatUnassignedPatients(
                          item.cases,
                          handleCaseClick,
                          handleCareNavigatorCardClick,
                          handleAssignModal,
                          (case_id: string, priority: string) =>
                            handleChangePriority(
                              case_id,
                              priority,
                              item.group_id,
                            ),
                          loginPageStore?.userResponse?.cnId ?? '',
                          handleMenuOnClick,
                          loginPageStore.memberIdentification,
                        )}
                      />
                    )
                  }
                  rightItem={
                    <Grid className={classes.rightItem}>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="normal"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemTitle}
                      >
                        No. of members
                      </Typography>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="medium"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemValue}
                      >
                        {item.cases.length}
                      </Typography>
                    </Grid>
                  }
                />
              </Grid>
            ))}
          />
          <CardComponent
            title={messages.TITLE.activeCases}
            width="1176px"
            body={activeData?.map((item) => (
              <Grid className={classes.accordion}>
                <BasicAccordion
                  title={item.group_name}
                  width={'1141px'}
                  height={'70px'}
                  expandDefault={activeData.length === 1}
                  content={
                    item.cases?.length === 0 ? (
                      <Grid className={classes.emptyData}>
                        <NoDataVisual
                          content="No Data Available"
                          height="200px"
                        />
                      </Grid>
                    ) : (
                      <BasicTable
                        width="1105px"
                        columns={activeTableColumns}
                        rowsData={formatActivePatients(
                          item.cases,
                          handleCaseClick,
                          handleCareNavigatorCardClick,
                          handleMenuOnClick,
                          loginPageStore.memberIdentification,
                        )}
                      />
                    )
                  }
                  rightItem={
                    <Grid className={classes.rightItem}>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="normal"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemTitle}
                      >
                        No. of members
                      </Typography>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="medium"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemValue}
                      >
                        {item.cases.length}
                      </Typography>
                    </Grid>
                  }
                />
              </Grid>
            ))}
          />
          <CardComponent
            title={messages.TITLE.closedCases}
            width="1176px"
            body={closeData?.map((item) => (
              <Grid className={classes.accordion}>
                <BasicAccordion
                  title={item.group_name}
                  width={'1141px'}
                  height={'70px'}
                  expandDefault={closeData.length === 1}
                  content={
                    item.cases?.length === 0 ? (
                      <Grid className={classes.emptyData}>
                        <NoDataVisual
                          content="No Data Available"
                          height="200px"
                        />
                      </Grid>
                    ) : (
                      <BasicTable
                        width="1105px"
                        columns={closedTableColumns}
                        rowsData={formatClosedPatients(
                          item.cases,
                          handleCaseClick,
                          true,
                          handleMenuOnClick,
                          loginPageStore.memberIdentification,
                        )}
                      />
                    )
                  }
                  rightItem={
                    <Grid className={classes.rightItem}>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="normal"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemTitle}
                      >
                        No. of members
                      </Typography>
                      <Typography
                        fontSize="14px"
                        lineHeight="22px"
                        fontType="medium"
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        className={classes.rightItemValue}
                      >
                        {item.cases.length}
                      </Typography>
                    </Grid>
                  }
                />
              </Grid>
            ))}
          />
        </Grid>
      )}
      {isAssignModal && (
        <AssignCareNavModal
          open={isAssignModal}
          handleClose={() => setIsAssignModal(false)}
          handleSave={handleSave}
          isSaveButtonDisabled={!assignData.cn_id}
          columns={careNavColumns}
          rowsData={getModalData()}
          isReplaceModal={false}
          assignCareNavState={[assignData, setAssignData]}
          careNavFieldsData={careNavFieldsData}
          isCareNavigator={loginPageStore.isCareNavigator}
          handleSelfAssign={handleSelfAssignAndAccept}
        />
      )}
      {isReplaceModal && (
        <AssignCareNavModal
          open={isReplaceModal}
          handleClose={() => setIsReplaceModal(false)}
          handleSave={handleSave}
          isSaveButtonDisabled={!assignData.cn_id}
          columns={careNavColumns}
          rowsData={getModalData()}
          isReplaceModal={true}
          assignCareNavState={[assignData, setAssignData]}
          careNavFieldsData={careNavFieldsData}
          isCareNavigator={loginPageStore.isCareNavigator}
          handleSelfAssign={handleSelfAssignAndAccept}
        />
      )}
      {isAcceptModal && (
        <AcceptCaseModal
          open={isAcceptModal}
          handleClose={() => setIsAcceptModal(false)}
          handleSave={handleAccept}
          isSaveButtonDisabled={!assignData.case_id}
          columns={careNavColumns}
          rowsData={getModalData()}
        />
      )}
      {isDeleteGroupPopup && (
        <DeleteGroupConfirmModal
          open={isDeleteGroupPopup}
          handleSave={handleDeleteCase}
          handleClose={handleCloseDeleteGroup}
          groupName={deleteGroupData?.case_id}
          title={
            deleteGroupData?.case_status === 'close'
              ? messages.TITLE.closedDelete
              : deleteGroupData?.case_status === 'active'
              ? messages.TITLE.activeDelete
              : messages.TITLE.unassignedDelete
          }
          interaction={
            deleteGroupData?.case_status === 'close'
              ? messages.SUB_TITLE.closedSubTitle
              : deleteGroupData?.case_status === 'active'
              ? messages.SUB_TITLE.activeSubTitle
              : ''
          }
        />
      )}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </Grid>
  );
};
export default CasesTab;
